// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image-wrapper[data-v-0a2d2b17]{display:flex;align-items:center;gap:.4rem}.image-wrapper>img[data-v-0a2d2b17]{width:6rem;height:4rem;-o-object-fit:cover;object-fit:cover;border-radius:.5rem;transition:.2s;cursor:pointer;flex-wrap:wrap}@media (max-width:500px){.image-wrapper>img[data-v-0a2d2b17]{width:4rem;height:3rem}}.image-wrapper>img[data-v-0a2d2b17]:hover{transform:scale(1.03);border-radius:.5rem}", ""]);
// Exports
module.exports = exports;
